import { v4 as uuidv4 } from "uuid";

const getScope = (auth, endpoint, siteId) => {
  const scopeLevel = auth.scopeLevel;
  const realmId = auth.realm?.id;
  const orgId = auth.orgs?.id;
  const isEnterprise = Boolean(orgId);
  const prefix = isEnterprise ? "/ents" : "";
  const resourceOrgId = isEnterprise ? orgId : realmId;
  const paths = {
    discovery: {
      org: "/orgs/devices/provision/discovery.read",
      site: "/orgs/sites/devices/provision/discovery.read",
    },
    sites: { org: "/orgs/sites.read", site: "/orgs/sites.read" },
    adopt: { org: "/orgs/devices/provision/adopt.read", site: "/orgs/devices/provision/adopt.read" },
  };
  const placeholder = isEnterprise
    ? { entId: realmId, orgId: resourceOrgId }
    : { orgId: resourceOrgId };
  const resolvedSiteId = siteId || (scopeLevel === "site" ? auth.sites?.id : null);
  if (resolvedSiteId) placeholder.siteId = resolvedSiteId;

  return {
    apiKey: `${prefix}${paths[endpoint][scopeLevel]}`,
    placeholder,
  };
};
const withRequestId = (data) => ({ ...data, socketId: uuidv4() });

export const makeSonicosDiscoveryRequest = ({ auth, proxyUuid, entries, includeCredentials = false }) => {
  const { apiKey, placeholder } = getScope(auth, "discovery");
  const data = includeCredentials
    ? entries.map((entry) => ({
      ipVersion: 4,
      ipList: [entry.ipAddress.trim()],
      username: entry.username,
      password: entry.password,
    }))
    : [{
      ipVersion: 4,
      ipList: [...new Set(entries.map((entry) => entry.ipAddress.trim()))],
    }];

  return withRequestId({
    apiKey,
    placeholder,
    params: {
      action: "start",
      timeout: 30,
      proxyUuid,
      discoveryProtocol: "sonicos",
      data,
    },
  });
};

export const makeSonicosStopRequest = ({ auth }) => {
  const { apiKey, placeholder } = getScope(auth, "discovery");
  return withRequestId({
    apiKey,
    placeholder,
    params: { action: "stop", timeout: 30, discoveryProtocol: "sonicos" },
  });
};

export const makeSonicosSitesRequest = (auth) => {
  const { apiKey, placeholder } = getScope(auth, "sites");
  return withRequestId({ apiKey, placeholder, params: null });
};

export const makeSonicosPreConfirmRequest = ({ auth, siteId, devices }) => {
  const scopeLevel = auth.scopeLevel;
  const realmId = auth.realm?.id;
  const orgId = auth.orgs?.id;
  const isEnterprise = Boolean(orgId);
  const apiKey = `${isEnterprise ? "/ents" : ""}/orgs/license/service/subscribe/preConfirm`;
  const placeholder = isEnterprise ? { entId: realmId, orgId } : { orgId: realmId };

  return withRequestId({
    apiKey,
    placeholder,
    params: [{
      siteId: scopeLevel === "site" ? auth.sites?.id : siteId,
      action: "add",
      devices: devices.map((device) => ({
        modelName: device.modelName,
        deviceId: device.macAddress,
      })),
    }],
  });
};

export const makeSonicosAdoptRequest = ({ auth, siteId, proxyUuid, devices }) => {
  const { apiKey, placeholder } = getScope(
    auth,
    "adopt",
    siteId === "inventory" ? null : siteId,
  );
  return withRequestId({
    apiKey,
    placeholder,
    params: {
      siteId: siteId === "inventory" ? null : siteId,
      proxyUuid,
      devices: devices.map((device) => ({
        modelName: device.modelName || "",
        hardwareVersion: device.hardwareVersion || "",
        deviceId: device.macAddress,
        productCategory: "Switch",
        version: device.version || "",
        protocolType: "sonicos",
        localIp: device.ipAddress || "",
        deviceAccount: { username: device.username || "", password: device.password || "" },
        ddp: { setAgProfile: false },
        switchRole: (device.role || "Spine").toLowerCase(),
      })),
    },
  });
};
